<template>
    <div class="student-page">
        <div class="term-box">

            <div class="term-item">
                <div class="term-title">{{$t('res.imgType')}}</div>
                <div class="term-content content-radio">
                    <el-radio-group v-model="formSearch.type" size="medium" @change="queryStock">
                        <el-radio-button label="DR"></el-radio-button>
                        <el-radio-button label="CT"></el-radio-button>
                    </el-radio-group>
                </div>
            </div>

            <div class="term-item">
                <div class="term-title">{{$t('c.knowledgePoint')}}</div>
                <div class="term-content">
                    <label :class="{'active': formSearch.knowledges.indexOf(0) > -1}">
                        <span>{{$t('c.all')}}</span>
                        <input type="checkbox" v-model="formSearch.knowledges" :value="0"
                               @change="checkboxAll('knowledges')">
                    </label>
                    <label v-for="item in imageKnowledgeMenu"
                           :class="{'active': formSearch.knowledges.indexOf(item.id) > -1, 'disabled': formSearch.knowledges.indexOf(0) > -1}"
                           :key="item.id">
                        <span>{{item.value}}</span>
                        <input type="checkbox" v-model="formSearch.knowledges" :value="item.id"
                               @change="choose('knowledges', 'imageKnowledgeMenu')"
                               :disabled="formSearch.knowledges.indexOf(0) > -1">
                    </label>
                </div>
            </div>

            <div class="term-item">
                <div class="term-title">{{$t('count.quantity')}}</div>
                <div class="item-count">
                    <el-slider
                        v-model="formSearch.count"
                        :min="0"
                        :max="stock"
                        :disabled="!stock"
                        style="padding-top: 10px;"
                        show-input
                        :step="5"
                        show-stops
                        @change="sliderChange"
                    >
                    </el-slider>
                    <p>/ <span style="font-size: 12px;">{{stock}}</span></p>
                </div>
            </div>
        </div>

        <div class="btn-group">
            <el-button type="primary" @click="startStudy" :disabled="formSearch.count === 0">{{$t('stu.startStudy')}}</el-button>
        </div>

        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </div>
</template>

<script>
import qs from 'qs';
import api from '@/api';
import { mapGetters } from 'vuex';
import selectMultiKnowledge from '@/components/SelectMultiKnowledge';
import paperExam from '@/components/Paper/PaperExam';
import FullScreen from '@/components/FullScreen.vue';

export default {
    name: 'ImgStudy',
    components: {
        selectMultiKnowledge,
        paperExam,
        FullScreen
    },
    watch: {
        'formSearch.knowledges'(val) {
            this.queryStock();
        }
    },
    data() {
        return {
            isShow: false,
            src: '',
            formSearch: {
                type: 'DR',
                knowledges: [],
                count: 20
            },
            stock: 100,
        }
    },
    created() {
        this.queryStock();

        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Image'
        });
    },
    computed: {
        ...mapGetters([
            'knowledgeMenu',
            'wsTrainee',
        ]),
        imageKnowledgeMenu() {
            return this.knowledgeMenu.Image.length ? this.knowledgeMenu.Image[0].children : []
        }
    },
    methods: {
        checkboxAll(name) {
            if (this.formSearch[name].indexOf(0) > -1) {
                this.formSearch[name] = [0];
            }
        },
        choose(name, listName) {
            if (this.formSearch[name].length === this[listName].length) {
                this.formSearch[name] = [0];
            }
        },
        queryStock() {
            let queryData = {...this.formSearch};
            delete queryData.count;

            if (this.formSearch['knowledges'].length == 1 && this.formSearch['knowledges'][0] == 0) {
                delete queryData['knowledges'];
            }

            api.getImgStudyStock(queryData).then(res => {
                if (!res.package) {
                    this.stock = 0;
                    this.formSearch.count = 0;
                    return;
                }
                this.stock = res.package > 100 ? 100 : res.package;
                this.formSearch.count = 20;
            });
        },
        startStudy() {
            let queryData = {...this.formSearch};
            if (queryData['knowledges'].length == 1 && queryData['knowledges'][0] == 0) {
                queryData['knowledges'] = []
            }

            let {type, knowledges, count} = queryData
            let routeParams = {
                limit: count,
                lang: this.$i18n.locale
            }
            if (knowledges.length > 0) {
                routeParams.knowledges = knowledges
            }
            routeParams = qs.stringify(routeParams, { arrayFormat: 'repeat' })
            this.isShow = !this.isShow
            if (type === 'DR') {
                this.src = `${api.imagePanoramicHost}/drStudy?${routeParams}`
                // this.src = `/static/3D/DR_base.html?type=IMAGE_STUDY&knowledges=${JSON.stringify(knowledges)}&count=${count}`
            } else {
                this.src = `${api.imagePanoramicHost}/ctStudy?${routeParams}`
                // this.src = `/static/3D/CT_base.html?type=IMAGE_STUDY&knowledges=${JSON.stringify(knowledges)}&count=${count}`
            }
            this.$refs.nstswrap.fullScreen()
            // signalR:记录“练习”行为
            this.wsTrainee.send('SJoinPractice')
        },
        toggleIsShow (val) {
            this.isShow = val
            this.src = null
            // signalR:记录“退出练习”行为
            !val && this.wsTrainee.send('SLeavePractice')
        },
        sliderChange(val) {
            if (val % 1) {
                this.formSearch.count = Math.round(val);
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../../style/const';

.student-page {
    margin-top: 70px;
}

.term-box {
    box-shadow: 0 3px 20px #c5d0dd;
    user-select: none;
}

.term-item {
    display: flex;
    border-bottom: 1px solid #dedede;
}

.term-title {
    width: 150px;
    line-height: 56px;
    font-size: 17px;
    text-align: center;
    background-color: #F4F3F8;
    letter-spacing: .5px;
}

//$c-active: #2E7FAA;

.term-content {
    padding: 15px 15px 0 15px;
    flex: 1;

    > label {
        position: relative;
        display: inline-block;
        padding: 0 10px;
        margin-left: 20px;
        margin-bottom: 15px;
        line-height: 26px;
        border: 1px solid transparent;
        background-color: transparent;
        border-radius: 13px;
        cursor: pointer;

        > input {
            position: absolute;
            clip: rect(0, 0, 0, 0);
        }

        &.active {
            color: #fff;
            border-color: $color-theme;
            background-color: $color-theme;
        }

        &.disabled {
            color: #bbb;
            cursor: not-allowed;

            & + .label-parent {
                color: #bbb;
            }
        }
    }

    &.content-radio {
        padding: 10px 30px 10px 40px;
    }
}

.item-count {
    display: flex;
    padding-left: 40px;

    .el-slider {
        width: 480px;
    }
    > p {
        margin-left: 16px;
        line-height: 56px;
        font-weight: 600;
    }
}

.btn-group {
    margin-top: 70px;
    text-align: center;

    button {
        padding: 15px 40px;
        font-size: 16px;
        letter-spacing: 1px;
    }
}
</style>
<style lang="scss">
.item-count .el-slider {
    input {
        font-weight: 600;
        font-size: 15px;
    }
}
</style>
